import React from 'react';
import { Box } from '@material-ui/core';

export const AppDetailsItemHeader = ({
    header,
    button,
}: {
    header: string;
    button?: React.ReactNode;
}) => {
    return (
        <Box display={'flex'} justifyContent={'space-between'} pb={2}>
            <Box fontSize={'28px'} fontWeight={'300'}>
                {header}
            </Box>
            {button && <Box>{button}</Box>}
        </Box>
    );
};
